/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import moment from "moment";

interface ContasReceber {
  parceiro: string;
  vencimento: string;
  historico: string;
  cpf: string;
  numero: string;
  venda: number;
  vparcela: number;
  vrecebido: number;
  acrescimo: number;
  desconto: number;
  vreceber: number;
}

async function RelatorioReceber(dados: ContasReceber[], periodo: string) {

  const totalGeral = dados.reduce(
    (acc, item) => acc + (item?.vreceber ?? 0),
    0
  );

  const linhas: any[] = [];

  dados.forEach((r) => {

    linhas.push([
      {
        text: moment(r.vencimento).format("DD/MM/YYYY"),
        fontSize: 8
      },
      {
        text: r.numero ?? "",
        fontSize: 8
      },
      {
        text: r.parceiro + " - " + r.cpf,
        fontSize: 8
      },
     
      {
        text: formatMoney(r.venda),
        alignment: "right",
        fontSize: 8
      },
      {
        text: formatMoney(r.vparcela),
        alignment: "right",
        fontSize: 8
      },
      {
        text: formatMoney(r.vrecebido),
        alignment: "right",
        fontSize: 8
      },
      {
        text: formatMoney(r.acrescimo),
        alignment: "right",
        fontSize: 8
      },
      {
        text: formatMoney(r.desconto),
        alignment: "right",
        fontSize: 8
      },
      {
        text: formatMoney(r.vreceber),
        alignment: "right",
        bold: true,
        fontSize: 8
      }
    ]);

  });

  const documentDefinition: any = {

    pageSize: "A4",
    pageMargins: [25, 25, 25, 25],

    content: [

      {
        text: process.env.REACT_APP_URL_EMPRESA,
        fontSize: 14,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 4]
      },

      {
        text: "RELATÓRIO DE CONTAS A RECEBER",
        fontSize: 12,
        bold: true,
        alignment: "center"
      },

      {
        text: periodo,
        alignment: "center",
        fontSize: 9,
        margin: [0, 0, 0, 10]
      },

      {
        table: {
          headerRows: 1,
          widths: [50, 25, "*", 40, 40, 40, 40, 40, 40],

          body: [

            [
              { text: "Venc.", bold: true, fillColor: "#e5e7eb", fontSize: 8 },
              { text: "Nº", bold: true, fillColor: "#e5e7eb", fontSize: 8 },
              { text: "Cliente", bold: true, fillColor: "#e5e7eb", fontSize: 8 },
              { text: "Venda", bold: true, alignment: "right", fillColor: "#e5e7eb", fontSize: 8 },
              { text: "Parcela", bold: true, alignment: "right", fillColor: "#e5e7eb" , fontSize: 8 },
              { text: "Recebido", bold: true, alignment: "right", fillColor: "#e5e7eb" , fontSize: 8 },
              { text: "Acrés", bold: true, alignment: "right", fillColor: "#e5e7eb" , fontSize: 8 },
              { text: "Desc", bold: true, alignment: "right", fillColor: "#e5e7eb" , fontSize: 8 },
              { text: "A Receber", bold: true, alignment: "right", fillColor: "#e5e7eb" , fontSize: 8 },
            ],

            ...linhas

          ]
        },

        layout: {

          fillColor: function (rowIndex: number) {

            if (rowIndex === 0) return null;

            return rowIndex % 2 === 0 ? "#f9fafb" : null;

          },

          hLineColor: () => "#d1d5db",
          vLineWidth: () => 0

        }
      },

      {
        text: "TOTAL A RECEBER: " + formatMoney(totalGeral),
        alignment: "right",
        bold: true,
        fontSize: 11,
        margin: [0, 15, 0, 0]
      }

    ]
  };

  pdfMake.createPdf(documentDefinition).open();
}

function formatMoney(value: number) {

  const v = Number(value ?? 0);

  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(v.toFixed(2)));

}

export default RelatorioReceber;